import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "M0 0h24v24H0z" }),
      _createElementVNode("g", {
        fill: "#FFF",
        "fill-rule": "nonzero"
      }, [
        _createElementVNode("path", { d: "M2.641 6.639h3.353a2.526 2.526 0 0 0 2.439 1.88c1.169 0 2.154-.8 2.438-1.88H21.36a.641.641 0 0 0 0-1.283H10.87a2.526 2.526 0 0 0-2.438-1.88c-1.169 0-2.154.8-2.439 1.88H2.641a.641.641 0 0 0 0 1.283m5.792-1.88c.683 0 1.24.555 1.24 1.238a1.24 1.24 0 0 1-1.24 1.24 1.24 1.24 0 0 1-1.24-1.24c0-.683.557-1.239 1.24-1.239M21.359 11.2h-4.273a2.526 2.526 0 0 0-2.438-1.881c-1.17 0-2.155.8-2.439 1.88H2.641a.641.641 0 0 0 0 1.282h9.568a2.526 2.526 0 0 0 2.439 1.88c1.169 0 2.154-.799 2.438-1.88h4.273a.641.641 0 1 0 0-1.282m-6.711 1.88a1.24 1.24 0 0 1-1.24-1.24 1.24 1.24 0 0 1 2.479 0 1.24 1.24 0 0 1-1.24 1.24M21.359 17.042H10.87a2.526 2.526 0 0 0-2.438-1.88c-1.169 0-2.154.8-2.439 1.88H2.641a.641.641 0 0 0 0 1.282h3.353a2.526 2.526 0 0 0 2.439 1.88c1.169 0 2.154-.8 2.438-1.88H21.36a.641.641 0 0 0 0-1.282m-12.926 1.88a1.24 1.24 0 0 1-1.24-1.24 1.24 1.24 0 0 1 2.479 0 1.24 1.24 0 0 1-1.239 1.24" })
      ])
    ], -1)
  ]))]))
}
export default { render: render }